import apiClient from './client';
import type {
  Canvas,
  CanvasSummary,
  CreateCanvasPayload,
  UpdateCanvasPayload,
} from '@/types/canvas.types';

export const canvasesApi = {
  listByWorkspace: async (workspaceId: string): Promise<CanvasSummary[]> => {
    const { data } = await apiClient.get<CanvasSummary[]>('/canvases', {
      params: { workspaceId },
    });
    return data;
  },

  getById: async (canvasId: string): Promise<Canvas> => {
    const { data } = await apiClient.get<Canvas>(`/canvases/${canvasId}`);
    return data;
  },

  create: async (payload: CreateCanvasPayload): Promise<Canvas> => {
    const { data } = await apiClient.post<Canvas>('/canvases', payload);
    return data;
  },

  update: async (canvasId: string, payload: UpdateCanvasPayload): Promise<Canvas> => {
    const { data } = await apiClient.patch<Canvas>(`/canvases/${canvasId}`, payload);
    return data;
  },

  delete: async (canvasId: string): Promise<void> => {
    await apiClient.delete(`/canvases/${canvasId}`);
  },
};

export default canvasesApi;
